export default "__VITE_PUBLIC_ASSET__b30f6010__"